module.exports = __webpack_public_path__ + "img/ETH_legadembi_landscape.b867aa41.jpg";